import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/general/NavigationBar.css';
  
const NavigationBar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg navbar-dark fixed-top gnb-custom-navbar ${scrolled ? 'gnb-scrolled' : ''}`}>
      <div className="container-fluid">
        {/* Logo */}
        <a className="navbar-brand gnb-navbar-brand d-flex align-items-center" href="#home">
          <div className="gnb-logo-icon me-2">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="2" fill="none">
                <animate attributeName="stroke-dasharray" values="0 113;113 0" dur="2s" repeatCount="indefinite"/>
              </circle>
              <circle cx="20" cy="20" r="12" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.6">
                <animate attributeName="stroke-dasharray" values="75 0;0 75" dur="2s" repeatCount="indefinite"/>
              </circle>
              <circle cx="20" cy="20" r="6" fill="currentColor" opacity="0.8">
                <animate attributeName="opacity" values="0.8;1;0.8" dur="2s" repeatCount="indefinite"/>
              </circle>
            </svg>
          </div>
          <span className="gnb-logo-text">CircleHub</span>
        </a>

        {/* Mobile Toggle Button */}
        <button 
          className="navbar-toggler gnb-navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
          aria-controls="navbarNav" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon gnb-navbar-toggler-icon"></span>
        </button>

        {/* Navigation Menu */}
        <div className="collapse navbar-collapse gnb-navbar-collapse" id="navbarNav">
          <ul className="navbar-nav gnb-navbar-nav mx-auto">
            <li className="nav-item gnb-nav-item">
              <Link className="nav-link gnb-nav-link gnb-active" to="/">Home</Link>
            </li>
            <li className="nav-item gnb-nav-item">
              <Link className="nav-link gnb-nav-link" to="/about">About</Link>
            </li>
            <li className="nav-item gnb-nav-item">
              <Link className="nav-link gnb-nav-link" to="/ai">IlamAI</Link>
            </li>
            <li className="nav-item gnb-nav-item">
              <Link className="nav-link gnb-nav-link" to="/domains">Domains</Link>
            </li>
            <li className="nav-item gnb-nav-item">
              <Link className="nav-link gnb-nav-link" to="/contact">Contact</Link>
            </li>
          </ul>

          {/* Login Button */}
          <div className="d-flex gnb-navbar-actions">
            <Link to="/login" className="btn gnb-btn-login">
              <span className="gnb-btn-text">Login / Sign Up</span>
              <svg className="gnb-btn-arrow" width="18" height="18" viewBox="0 0 16 16" fill="none">
                <path
                  d="M1 8H15M15 8L8 1M15 8L8 15"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;